import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { getQuizConfig } from 'platform-components/src/components/app-factory/selectors';
import { QuizStore, QuizStoreState } from 'platform-components/src/components/quiz/typings';
import { createSelector } from 'reselect';

import { QuizEditorStore, QuizEditorStoreState } from './typings';

const quizEditorStoreSelector = (storeState: QuizEditorStore): QuizEditorStoreState => storeState.quizEditor;

const quizStoreSelector = (storeState: QuizStore): QuizStoreState => storeState.quiz;

export const getQuizToPreview = createSelector(quizStoreSelector, (quizStoreState) => quizStoreState.quizToPreview);

export const getQuizDraft = createSelector(quizEditorStoreSelector, (storeState) => storeState.quizDraft);

export const getQuestions = createSelector(getQuizDraft, (quizDraft) => quizDraft.questions);

export const getCurrentQuestionIndex = createSelector(
    quizEditorStoreSelector,
    (storeState) => storeState.currentQuestionIndex
);

export const getCurrentQuestion = createSelector(
    [getQuestions, getCurrentQuestionIndex],
    (questions, currentQuestionIndex) => {
        return questions[currentQuestionIndex];
    }
);

export const getCurrentQuestionTitle = createSelector(getCurrentQuestion, (question) => question.title);

export const getCurrentQuestionAnswers = createSelector(getCurrentQuestion, (question) => question.answers);

export const getSendStatus = createSelector(
    quizEditorStoreSelector,
    (storeState): LOADING_STATUSES => storeState.sendStatus
);

export const getQuizIsValidStatus = createSelector(getQuizDraft, (quizDraft) => quizDraft.isValid);

export const getViewType = createSelector(quizEditorStoreSelector, (storeState) => storeState.viewType);

export const isReadOnly = createSelector(quizEditorStoreSelector, (storeState) => storeState.isReadOnly);

export const getQuizLoadingStatus = createSelector(
    quizEditorStoreSelector,
    (storeState) => storeState.quizLoadingStatus
);

const getQuizzesViewConfig = createSelector(getQuizConfig, (quizConfig) => quizConfig.quizzesViewConfig);

export const getTitleMaxLength = createSelector(
    getQuizzesViewConfig,
    (quizzesViewConfig) => quizzesViewConfig.titleMaxLength
);

export const getQuestionMaxLength = createSelector(
    getQuizzesViewConfig,
    (quizzesViewConfig) => quizzesViewConfig.questionMaxLength
);

export const getAnswerMaxLength = createSelector(
    getQuizzesViewConfig,
    (quizzesViewConfig) => quizzesViewConfig.answerMaxLength
);
